import { useEffect } from "react";

/** Titre + description par page. */
export function Seo({ title, description, noindex }) {
  useEffect(() => {
    const full = `${title} · KM01`;
    document.title = full;
    const set = (selector, attr, key, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    set('meta[name="description"]', "name", "description", description || "");
    set('meta[property="og:title"]', "property", "og:title", full);
    set('meta[property="og:description"]', "property", "og:description", description || "");
    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      set('meta[name="robots"]', "name", "robots", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, noindex]);
  return null;
}
